<div>
  <form [formGroup]="form">
    <div
      #userContainer
      *ngIf="inputItems.length"
      [ngClass]="{ scrollable: inputItems.length > 10 }"
      class="container-assign mb-15"
      formArrayName="inputItems"
    >
      <div *ngFor="let user of inputItems.controls; let i = index">
        <div [formGroupName]="i" class="input-wrap">
          <div
            (click)="clearInput(user, i)"
            *ngIf="user.get('id').value !== superAdminId"
            [ngClass]="{
              disable: user.get('id').value === superAdminId
            }"
            [pTooltip]="'Clear'"
            [tooltipPosition]="'top'"
            class="grid justify-content-center align-items-center btn-remove"
          >
            <span>&times;</span>
          </div>

          <input
            id="{{ 'emailId' + i }}"
            (blur)="setInputAsValid()"
            (change)="setInputValue($event.target.value, i)"
            [ngClass]="{
              disable:
                user.get('id').value === superAdminId ||
                (user.get('emailId').value && user.get('isCharged').value)
            }"
            [placeholder]="i === 0 ? 'jeff@pitch59.com' : 'Email'"
            appNoLeadingSpace
            autocomplete="nope"
            class="new-input-box sm"
            formControlName="emailId"
            pInputText
            type="text"
          />

          <div *ngIf="user.get('emailId').errors" class="form-errors">
            <div
              *ngIf="
                user.get('emailId').errors.pattern ||
                user.get('emailId').errors.failed
              "
              translate
            >
              {{ errorMessage ? errorMessage : 'err_invalid_emailId' }}
            </div>

            <div
              *ngIf="
                user.get('emailId').errors.duplicate &&
                user.get('emailId').touched
              "
              translate
            >
              This user is already an admin.
            </div>
          </div>

          <div
            *ngIf="user.get('id').value === superAdminId"
            class="disable-overlay"
          ></div>
        </div>
      </div>
    </div>

    <div class="p-grid p-justify-start no-margins">
      <button
        (click)="addAdditionalAdminsModal = true"
        [disabled]="form.invalid"
        class="button-simple shock-pink sm-25"
        type="button"
      >
        <span class="pi pi-plus mr-1"></span>Add More
      </button>
    </div>

    <div class="grid justify-content-end no-margins">
      <button
        (click)="saveChanges($event)"
        class="button-simple shock-pink sm-35 uppercase"
        translate
        type="submit"
      >
        label_save_finish
      </button>
    </div>
  </form>
</div>

<p-dialog
  (onHide)="additionalNumberOfAdmins = 2"
  [(visible)]="addAdditionalAdminsModal"
  [blockScroll]="true"
  [closeOnEscape]="true"
  [dismissableMask]="false"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [style]="{ minWidth: '300px', maxWidth: '550px', width: '550px' }"
  appendTo="body"
  styleClass="dialog"
>
  <div class="modal-layout" style="padding: 5%">
    <div class="modal-header">
      <h2 class="no-margins">How many Administrators would you like to add?</h2>
    </div>

    <div class="modal-body mb-30">
      <div class="mt-20 mb-20">
        <p-inputNumber
          [(ngModel)]="additionalNumberOfAdmins"
          [max]="99"
          [min]="1"
          [showButtons]="true"
          mode="decimal"
        >
        </p-inputNumber>
      </div>
    </div>

    <div class="modal-footer">
      <div class="grid justify-content-end align-items-center">
        <div class="mr-2">
          <button
            (click)="addAdditionalAdminsModal = false"
            class="button-simple sm-35 bg-darkgray white"
          >
            {{ 'CANCEL' | uppercase }}
          </button>
        </div>
        <button
          (click)="addMoreInputs()"
          class="button-simple sm-35 shock-pink"
        >
          {{ 'Add Administrators' | uppercase }}
        </button>
      </div>
    </div>
  </div>
</p-dialog>
